import SchoolIcon from "@mui/icons-material/School";
import { GraduationServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListInternshipStudents from "./List";
import ShowInternshipStudents from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <SchoolIcon />,
  name: GraduationServicePath + "students",
  title: "Студенти",
  list: <ListInternshipStudents />,
  show: <ShowInternshipStudents />,
  permission: permissions.canPreviewInternshipStudents,
};
